import React from "react";
import { Accordion, Container, Button } from "react-bootstrap";

const faqData = [
  {
    id: 1,
    question: "What support does ProofTec offer?",
    answer: (
      <>
        We offer email support and aim to respond within 48 hours. If you need
        assistance, email us at{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="mailto:support@prooftec.com"
        >
          support@prooftec.com
        </a>
        , and we&apos;ll be happy to help.
      </>
    ),
  },
  {
    id: 2,
    question: "Can I upgrade or downgrade my plan?",
    answer: (
      <>
        Yes, you can upgrade or downgrade your plan, but it depends on whether
        you have a monthly or yearly plan.
        <ul>
          <li>
            <strong>Monthly:</strong> You can upgrade or downgrade anytime.
            Upgrades take effect immediately, and downgrades start at the end of
            your monthly billing period.
          </li>
          <li>
            <strong>Yearly:</strong> Upgrades are allowed at any time.
            You&apos;ll just pay the difference for the rest of your plan.
            Downgrades aren&apos;t available until your plan renews.
          </li>
        </ul>
        To change your plan, email us at{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="mailto:sales@prooftec.com"
        >
          sales@prooftec.com
        </a>
        .
      </>
    ),
  },
  {
    id: 3,
    question: "Do I need a special device to take the images?",
    answer: (
      <>
        No, we support most Android and iOS devices, including phones and
        tablets. If you&apos;re unsure whether your device is supported, email
        us at{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="mailto:support@prooftec.com"
        >
          support@prooftec.com
        </a>
        , and we&apos;ll be happy to help.
      </>
    ),
  },
  {
    id: 4,
    question: "Does ProofTec integrate with quoting packages?",
    answer: (
      <>
        Yes, we offer integrations with some quoting packages.{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://prooftec.com/#contact-first-name"
        >
          Contact us
        </a>{" "}
        to learn more about our current and upcoming integrations.
      </>
    ),
  },
  {
    id: 5,
    question: "Is my data safe and where is it stored?",
    answer: (
      <>
        Yes, your data is safe. All images and metadata are stored on the Amazon
        Web Services (AWS) Cloud in Australia, which follows industry-leading
        security practices to protect your information.
      </>
    ),
  },
  {
    id: 6,
    question: "Can I cancel my plan at any time?",
    answer: (
      <>
        Yes, you can cancel anytime with no lock-in periods. If you cancel,
        you&apos;ll still have access to ProofTec until the end of your current
        billing period, whether it&apos;s monthly or yearly.
      </>
    ),
  },
  {
    id: 7,
    question: "What payment methods do you offer?",
    answer: (
      <>
        We accept all major credit cards and, in select countries, direct debit.
      </>
    ),
  },
];

const FaqSection = () => {
  return (
    <section className="text-center my-5 pt-5">
      <Container>
        <div>
          <h5 className="text-aqua fw-bold">Have any questions?</h5>
          <h1 className="mb-lg-5 mb-2">Frequently Asked Questions</h1>
        </div>

        <Accordion defaultActiveKey="" flush className="text-start">
          {faqData.map((faq) => (
            <Accordion.Item eventKey={faq.id.toString()} key={faq.id}>
              <Accordion.Header>{faq.question}</Accordion.Header>
              <Accordion.Body>{faq.answer}</Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>

        <p className="text-center mt-5">
          Still have questions?{" "}
          <a
            className="text-aqua fw-bold"
            target="_blank"
            rel="noopener noreferrer"
            href="https://prooftec.com/#contact-first-name"
          >
            Contact us.
          </a>
        </p>
      </Container>
    </section>
  );
};

export default FaqSection;
